import React, { useState } from 'react'
import './styles.scss'


export function Box(props) {


  return (
    <div className='box'>
      {(props.title && props.lead) &&
        <div className='ui text container'>
          {props.title && <h1>{props.title}</h1>}
          {props.lead && <span>{props.lead}</span>}
        </div>
      }
      {props.children}
    </div>
  )
}
